'use client';

import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { useState } from 'react';
import { CheckMarkIcon, CloudIcon, QuestionMarkIcon, RestartIcon } from '@/app/components/icons/animation-icons';

export default function ComparisonAnimation({ className = '' }: { className?: string }) {
  const [tl, setTl] = useState<gsap.core.Timeline | undefined>();

  const colTexts = [
    'Drtivá většina restaurací v marketingu tápe. Neumí plánovat, měřit a realizuje nahodile.',
    'Spoustu podniků se opravdu snaží, přesto v marketingu bloudí.',
    'Restaurační řetězce s početným interním týmem marketingových profesionálů.',
    'Možná jedno procento podniků v Česku má skutečně efektivní marketing se správně nastaveným měřením. <u>To je vaše příležitost</u>.',
  ];

  const colIcons = [
    <CloudIcon key={ 'cloud' } className={ 'icon a-icon opacity-0 fill-black mt-4 size-10' } />,
    <QuestionMarkIcon key={ 'questionmark' } className={ 'icon a-icon opacity-0 fill-black mt-4 size-10' } />,
    <RestartIcon key={ 'restart' } className={ 'icon a-icon opacity-0 fill-black mt-4 size-10' } />,
    <CheckMarkIcon key={ 'checkmark' } className={ 'icon a-icon opacity-0 fill-black mt-2 size-8' } />,
  ];

  useGSAP(() => {
    const columns = document.querySelectorAll('.a-column');
    const textElements = document.querySelectorAll('.a-text');
    const icons = document.querySelectorAll('.a-icon');

    const t = gsap.timeline({
      repeat: -1,
      scrollTrigger: {
        trigger: '.comparison-animation',
        start: 'top 100%',
        end: 'bottom 0%',
        toggleActions: 'play pause resume pause'
      }
    });
    if (!tl)
    {
      setTl(t);
    }
    else
    {
      tl.kill();
      setTl(t);
    }

    t.addLabel('start');
    for (let i = 0; i < columns.length; i++)
    {
      t.to(columns[i], {
        delay: 0.3,
        duration: 1,
        background: 'rgba(255, 255, 255, 1)',
        ease: 'power2.inOut',
      });
      t.to(textElements[i], {
        duration: 1,
        opacity: 1,
        ease: 'power2.inOut',
      }, '<');

      t.to(icons[i], {
        duration: 1,
        opacity: 1,
        ease: 'power2.inOut',
      }, '<');

      if (i === columns.length - 1)
      {
        t.fromTo(columns[i], {
          boxShadow: '0 0 0 0 rgba(141, 134, 255, 0)',
        }, {
          boxShadow: '0 -4px 0 4px rgba(141, 134, 255, 0.7), 0 -6px 0 6px rgba(141, 134, 255, 0.55), 0 -8px 0 8px rgba(141, 134, 255, 0.4)',
          duration: 2,
        });
      }

      t.to(columns[i], {
        delay: 1.5,
        duration: 1,
        background: 'rgba(255, 255, 255, 0.45)',
        ease: 'power2.inOut',
      });
      t.to(textElements[i], {
        duration: 1,
        opacity: 0,
        ease: 'power2.inOut',
      }, '<');
      t.to(icons[i], {
        duration: 1,
        opacity: 0,
        ease: 'power2.inOut',
      }, '<');

      if (i === columns.length - 1) {
        t.to(columns[i], {
          duration: 1,
          boxShadow: '0 0 0 0 rgba(141, 134, 255, 0)',
        }, '<');
      }
    }
  }, []);

  // const handleAnyClick = useCallback((e: MouseEvent) => {
  //   // const target = e.target as HTMLElement; // commented out because it was starting to play the animation on any click even if it never was in the view yet
  //   // if (!target.closest('.a-column'))
  //   // {
  //   //   if (tl?.paused())
  //   //   {
  //   //     tl?.resume();
  //   //     console.log('resuming animation');
  //   //   }
  //   // }
  // }, [tl]);

  // useEffect(() => {
  //   document.addEventListener('click', handleAnyClick);
  //
  //   return () => {
  //     document.removeEventListener('click', handleAnyClick);
  //   };
  // }, [handleAnyClick]);

  const handleColClick = (col: number) => {
    tl?.pause();

    const colElements = document.querySelectorAll(`.a-column`) as NodeListOf<HTMLElement>;
    const textElements = document.querySelectorAll(`.a-text`) as NodeListOf<HTMLElement>;
    const iconElements = document.querySelectorAll(`.a-icon`) as NodeListOf<HTMLElement>;
    colElements.forEach((e) => {
      e.style.background = 'rgba(255, 255, 255, 0.45)';
    });
    textElements.forEach((e) => {
      e.style.opacity = '0';
    });
    iconElements.forEach((e) => {
      e.style.opacity = '0';
    });
    colElements[col].style.background = 'rgba(255, 255, 255, 1)';
    textElements[col].style.opacity = '1';
    iconElements[col].style.opacity = '1';
  };

  return (
    <div className={ `${ className } @container comparison-animation w-full` }>
      <div className={ 'w-full h-44 grid grid-cols-4 gap-8 @max-sm:gap-2 items-end' }>
        { colIcons.map((icon, i) => (

          <div key={ `col-${ i }` }
               onClick={ () => handleColClick(i) }
               className={ `a-column acol-${ i } w-full bg-[rgba(255,_255,_255,_0.45)] rounded-t-lg flex items-start justify-center cursor-pointer` } style={{height: 100 - i * 20 + '%'}}>{ icon }</div>
        )) }
      </div>
      <div className={ 'text-white mt-4 text-left font-anybody font-stretch-condensed font-bold text-base grid grid-cols-1 grid-rows-1' }>
        { colTexts.map((columnDescription, i) => (
          <div key={ `col-desc-${ i }` }
               className={ `a-text col-start-1 col-end-2 row-start-1 row-end-2 opacity-0` }
               dangerouslySetInnerHTML={ { __html: columnDescription } }></div>
        )) }
      </div>
    </div>
  );
}
